import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { getDateStringForDisplay } from '@@/bits/time'
import calculateRelativeTime from '@@/bits/relative_time'
import { computed } from 'vue'

/**
 * Displays the duration relative to given date/time.
 */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzRelativeTime',
  props: {
    datetime: null,
    dateformat: { default: 'short' }
  },
  setup(__props: any) {

const props = __props as { datetime: string | number | Date, dateformat: 'short' | 'long' };



const relativeTime = computed(() => calculateRelativeTime(props.datetime, props.dateformat))

const actualTime = computed(() => getDateStringForDisplay(props.datetime))

return { __sfc: true,props, relativeTime, actualTime }
}

})